import {getMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/hotelDescription/${hotelId}/general`, request)
}

async function put(hotelId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/general`, request)
}

export {get, put}
